import {
    ARTICLE,
    ARTICLE_SUCCESS,
    ARTICLE_ERROR,
    ARTICLE_CARD_INFO,
    ARTICLE_CARD_INFO_SUCCESS,
    ARTICLE_CARD_INFO_ERROR,
    ARTICLE_CARD_SEARCH_SET,
    ARTICLE_CARD_SEARCH_CHANGE,
    ARTICLE_CARD_TAB_SET
} from '../actions';

const INIT_STATE = {
    loading: true,
    init: true,
    article: {
        data: [],
        loading: true,
    },
    cardarticle: {
        data: [],
        loading: true,
    },
    viewtab: {
        tab: '1',
        modal: false
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            idarticle: ''
        },
        value: {
            idarticle: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ARTICLE:
            return {
                ...state,
                init: false,
                article: {
                    ...state.article,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case ARTICLE_SUCCESS:
            return {
                ...state,
                article: {
                    ...state.article,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case ARTICLE_ERROR:
            return {
                ...state,
                article: {
                    ...state.article,
                    loading: false,
                    data: [],
                    message: 'No se encotraron datos'
                }
            }

        case ARTICLE_CARD_INFO:
            return {
                ...state,
                loading: true,
                cardarticle: {
                    ...state.cardarticle
                }
            }
        case ARTICLE_CARD_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                cardarticle: {
                    ...state.cardarticle,
                    ...action.payload
                }
            }
        case ARTICLE_CARD_INFO_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case ARTICLE_CARD_SEARCH_SET:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case ARTICLE_CARD_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    value: action.payload,
                }
            }
        case ARTICLE_CARD_TAB_SET:
            return {
                ...state,
                viewtab: {
                    ...state.viewtab,
                    tab: action.payload
                }
            }
        default:
            return { ...state };
    }

};